import { MAX_DISCOUNT_PCT } from '../config/constants';
import type { OfferLine } from '../models/Offer';
import { calculateDiscountedUsd, convertUsdToTnd } from './currency';

export const clampDiscount = (discountPct: number): number => Math.max(0, Math.min(MAX_DISCOUNT_PCT, Number(discountPct.toFixed(2))));

export const calculateTax = (subTotalTnd: number, taxRate: number): number => Number((subTotalTnd * taxRate).toFixed(3));

export const calculateTotalWithTax = (subTotalTnd: number, taxRate: number): number => Number((subTotalTnd + calculateTax(subTotalTnd, taxRate)).toFixed(3));

export const calculateOfferLineTotal = (quantity: number, unitPriceUsd: number, exchangeRate: number, discountPct: number): number => {
  const discountedUsd = calculateDiscountedUsd(unitPriceUsd, quantity, clampDiscount(discountPct));
  return convertUsdToTnd(discountedUsd, exchangeRate);
};

export const calculateOfferTotals = (lines: OfferLine[], taxRate: number): { subtotalUsd: number; subtotalTnd: number; taxAmountTnd: number; totalTnd: number } => {
  const subtotalUsd = Number(lines.reduce((sum, line) => sum + calculateDiscountedUsd(line.cr_crm_unitpriceusd, line.cr_crm_quantity, line.cr_crm_discountpct), 0).toFixed(2));
  const subtotalTnd = Number(lines.reduce((sum, line) => sum + line.cr_crm_linetotaltnd, 0).toFixed(3));
  const taxAmountTnd = calculateTax(subtotalTnd, taxRate);
  const totalTnd = calculateTotalWithTax(subtotalTnd, taxRate);
  return { subtotalUsd, subtotalTnd, taxAmountTnd, totalTnd };
};
